export const mutations = {
  SET_CONTRACT: (state, payload) => {
    state.contract = payload
  }
}
